import { render } from "./FlechaRotativa.vue?vue&type=template&id=78840e8d&scoped=true"
const script = {}

import "./FlechaRotativa.vue?vue&type=style&index=0&id=78840e8d&lang=sass&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78840e8d"]])

export default __exports__